import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiClientType, GlobalState } from "@/redux/global/types";
import { getStateKeyList } from "@/utils/redux/state";
import { getRestApiClient } from "@/api/api";

const name = "global";

const initialState: GlobalState = {
	topBar: true,
	isLoading: false,
	apiClient: getRestApiClient(),
};

export const GLOBAL_STATE_KEY_LIST = getStateKeyList(initialState);

export const globalSlice = createSlice({
	initialState,
	name,
	reducers: {
		setTopBar: (state, { payload }: PayloadAction<boolean>) => {
			state.topBar = payload;
		},
		setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
			state.isLoading = payload;
		},
		setApiClient: (state, { payload }: PayloadAction<ApiClientType>) => {
			state.apiClient = payload;
		},
	},
});

export const globalReducer = globalSlice.reducer;
